<template>
  <div class="personInfo">
    <el-dialog
      class="dialog-primary"
      title=""
      :visible.sync="infoVisible"
      :close-on-click-modal="false"
      width="62%"
      :before-close="handleClose">
      <div class="dialog-person-info">
        <img
          src="@/assets/img/orderPop.png"
          alt="" />
        <div class="dialog-person-info-btn">
          {{ currentPackageType }}
        </div>
        <div class="contact-info subscribe-version">
          <div class="qrcode">
            <img
              id="qrcodeInstance"
              class="qrcode-img"
              src="@/assets/img/subscribeQrCode.png" />
          </div>
          <div class="phone">
            <icon-svg
              icon-class="icon-lianxifangshi"
              class="icon"
              size="22" />
            13628508343
          </div>
        </div>
        <div class="contact-info private-version">
          <div class="qrcode">
            <img
              id="qrcodeInstance"
              class="qrcode-img"
              src="@/assets/img/subscribeQrCode.png" />
          </div>
          <div class="phone">
            <icon-svg
              icon-class="icon-lianxifangshi"
              class="icon"
              size="22" />
            13628508343
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus'
import QRCode from 'qrcode'
import { getSubScibe } from '@/service/personInfo'
import dayjs from 'dayjs'
export default {
  data() {
    return {
      infoVisible: false,
      QRCodeUrl: '',
      countInfo: {}
    }
  },
  computed: {
    canUsedSpace() {
      return this.countInfo.diskVolume + 'GB'
    },
    currentPackageType() {
      if (!this.countInfo) {
        return
      }
      return this.countInfo?.trialing
        ? '当前计划'
        : this.countInfo?.subscribing
        ? '已是付费版'
        : '账号已过期'
    },
    timeLong() {
      const endTime = dayjs(this.countInfo.trialExpirationTime)
      const time =
        endTime
          .diff(dayjs(this.countInfo.trialBeginTime), 'day', true)
          .toFixed(2) + '天'
      return time
    },
    subTime() {
      return dayjs(this.countInfo.trialBeginTime).format('YYYY-MM-DD')
    },
    endTime() {
      return dayjs(this.countInfo.trialExpirationTime).format('YYYY-MM-DD')
    }
  },
  methods: {
    handleClose() {
      this.infoVisible = false
    },

    async getPersonInfo() {
      const { data, isSuccess, errMsg } = await getSubScibe()
      if (errMsg) {
        return this.$message.error(errMsg)
      }
      eventBus.$emit('getSubInfo', data)
      this.countInfo = data
      return data
    },

    createQRCode(url) {
      return new Promise((resolve, reject) => {
        // 1. 生成基础二维码
        QRCode.toDataURL(
          url,
          {
            width: 72,
            margin: 2,
            color: {
              dark: '#000000',
              light: '#00000000' // 透明背景
            }
          },
          (error, qrUrl) => {
            if (error) {
              console.error('生成二维码失败:', error)
              reject(error)
              return
            }

            // 2. 创建canvas
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            canvas.width = 72
            canvas.height = 72

            // 3. 加载二维码图片
            const qrImg = new Image()
            qrImg.src = qrUrl

            qrImg.onload = () => {
              // 绘制透明背景二维码
              ctx.drawImage(qrImg, 0, 0)

              // 4. 创建挖空效果
              const logoSize = 18
              const logoX = (canvas.width - logoSize) / 2
              const logoY = (canvas.height - logoSize) / 2

              // 保存当前状态
              ctx.save()

              // 创建挖空路径
              ctx.beginPath()
              ctx.rect(logoX, logoY, logoSize, logoSize)
              ctx.clip() // 裁剪区域

              // 清除中心区域
              ctx.clearRect(logoX, logoY, logoSize, logoSize)

              // 恢复状态
              ctx.restore()

              // 5. 加载微信图标
              const wechatImg = new Image()
              wechatImg.src = require('@/assets/img/wx.webp')
              wechatImg.onload = () => {
                // 绘制白色背景（可选）
                ctx.fillStyle = '#ffffff'
                ctx.fillRect(logoX - 2, logoY - 2, logoSize + 4, logoSize + 4)

                // 绘制图标（比挖空区域稍小）
                const iconSize = logoSize * 0.9
                const iconX = (canvas.width - iconSize) / 2
                const iconY = (canvas.height - iconSize) / 2

                ctx.drawImage(wechatImg, iconX, iconY, iconSize, iconSize)

                // 6. 获取最终结果
                this.QRCodeUrl = canvas.toDataURL()
                resolve(this.QRCodeUrl)
              }

              wechatImg.onerror = err => {
                console.error('微信图标加载失败:', err)
                reject(err)
              }
            }

            qrImg.onerror = err => {
              console.error('二维码图片加载失败:', err)
              reject(err)
            }
          }
        )
      })
    }
  },
  async mounted() {
    this.createQRCode('https://example.com/subscribe')
    const currentInfo = await this.getPersonInfo()
    eventBus.$emit('getUserInfo', currentInfo)
    if (!currentInfo?.trialReminded) {
      this.infoVisible = true
    }
    eventBus.$on('showUserInfo', status => {
      this.infoVisible = status
    })
  }
}
</script>

<style scoped lang="less">
.personInfo {
  .dialog-primary {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  .dialog-person-info {
    height: 100%;
    display: flex;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      border-radius: 24px;
    }

    &-btn {
      width: 21%;
      height: 6%;
      background: rgba(193, 193, 193, 0.6);
      border-radius: 30px 30px 30px 30px;
      border: 1px solid rgba(0, 0, 0, 0);
      position: absolute;
      top: 47%;
      left: 8%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #ffffff;
    }
  }
  .dialog_left {
    flex-basis: 322px;
    background-image: url('@/assets/img/orderInfoBg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 36px 0 55px 36px;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;

    p {
      color: rgba(255, 255, 255, 0.9);
      text-align: left;
      font-size: 20px;
      font-weight: 400;
      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }

    & .dialog_left-account-info {
      text-align: left;
      color: #ffffff;
      font-size: 23px;
      font-weight: 500;
    }
  }
  .dialog-right {
    width: 198px;

    .link-our {
      color: rgba(33, 36, 41, 0.9);
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      padding-top: 36px;
      padding-bottom: 28px;
    }

    .qrcode {
      padding-bottom: 64px;
    }

    .phone {
      color: rgba(33, 36, 41, 0.6);
      font-size: 16px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;

      :deep(.icon) {
        color: rgba(33, 36, 41, 0.6);
        margin-right: 8px;
      }
    }
  }

  .contact-info {
    position: absolute;
    width: 150px;

    &.subscribe-version {
      top: 44%;
      left: calc(44% - 4px);
    }

    &.private-version {
      top: 44%;
      left: calc(75% + 4px);
    }

    .qrcode {
      width: 90px;
      height: 90px;
      margin: auto;
      box-shadow: 0px 20px 100px 0px rgba(220, 233, 249, 0.5);
    }

    .phone {
      color: rgba(33, 36, 41, 0.6);
      font-size: 16px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;

      :deep(.icon) {
        color: rgba(33, 36, 41, 0.6);
        margin-right: 8px;
      }
    }
  }

  :deep(.el-dialog) {
    margin-top: 11vh !important;
    height: 680px;
    min-width: 800px;
    background: transparent;
    box-shadow: none;
    border-radius: 16px;
    .el-dialog__header {
      height: 0;
      padding: 0 16px;
      color: var(--dialog-header-text-color);
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      .el-dialog__headerbtn {
        color: #fff;
        z-index: 9;
        // position: absolute;
        // right: -46px;
        // top: -32px;
        // width: 32px;
        // height: 32px;
        // border: 2px solid #fff;
        // border-radius: 50%;
        // cursor: pointer;

        // &:hover {
        //   &::after {
        //     background: rgba(255, 255, 255, 0.05);
        //     position: absolute;
        //     content: '';
        //     display: block;
        //     top: -6px;
        //     left: -6px;
        //     width: 100%;
        //     height: 100%;
        //     padding: 6px;
        //     border-radius: 8px;
        //   }
        // }

        .el-icon {
          color: #fff;
          font-size: 22px;
        }
      }
    }
    .el-dialog__body {
      height: 100%;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0 16px;
      border-top: 1px solid var(--dialog-footer-border-color);
      height: 302px;
    }
  }
}
</style>
